import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Column } from 'app/design/primitives/box';
import { Button } from 'app/design/primitives/button';
import { Page } from 'app/design/primitives/page';
import { BulkStepHeader } from './bulk-step-header';
import {
  ListingVisibilitySelector,
  type ListingVisibilitySelectorProps,
} from './components/listing-visibility-selector';

export interface BulkVisibility {
  addressIds: string[];
  groupIds: string[];
}

export function BulkVisibilityStep({
  addresses,
  groups,
  isBusy,
  onConfirm,
}: {
  addresses: ListingVisibilitySelectorProps['addresses'];
  groups: ListingVisibilitySelectorProps['groups'];
  isBusy: boolean;
  onConfirm: (visibility: BulkVisibility) => void;
}) {
  const { t } = useTranslation('new');
  const [excludedAddresses, setExcludedAddresses] = useState<string[]>([]);
  const [excludedGroups, setExcludedGroups] = useState<string[]>([]);
  const addressIds = addresses.filter(({ id }) => !excludedAddresses.includes(id)).map(({ id }) => id);
  const groupIds = groups.filter(({ id }) => !excludedGroups.includes(id)).map(({ id }) => id);

  return (
    <Page keyboardShouldPersistTaps="handled">
      <Column gap="spacing.general.x5">
        <BulkStepHeader stage="visibility" />
        <ListingVisibilitySelector
          addresses={addresses}
          groups={groups}
          value={{ addressIds, groupIds }}
          disabled={isBusy}
          showTitle={false}
          privateHint={t('bulk.visibility.privateHint')}
          onChange={(selection) => {
            setExcludedAddresses(addresses.filter(({ id }) => !selection.addressIds.includes(id)).map(({ id }) => id));
            setExcludedGroups(groups.filter(({ id }) => !selection.groupIds.includes(id)).map(({ id }) => id));
          }}
        />
        <Button
          disabled={isBusy}
          loading={isBusy}
          onPress={() => onConfirm({ addressIds, groupIds })}
          variant="primary"
        >
          {t('bulk.visibility.confirm')}
        </Button>
      </Column>
    </Page>
  );
}
